import { useState as e, useEffect as t } from "react";

const r = (r = 3e4) => {
    const [n, a] = e((() => new Date));
    return t((() => {
        const e = setInterval((() => a(new Date)), r);
        return () => clearInterval(e);
    }), [ r ]), n;
};

export { r as useLiveCurrentDate };
//# sourceMappingURL=useLiveCurrentDate.js.map
